import { useEffect, useState } from 'react';

const useMaxHeightChildElement = (parentElementId, childElementIdPrefix, data, open, mobilitySettings) => {
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    setMaxHeight(0);

    const timeout = setTimeout(() => {
      const parentElement = document.getElementById(parentElementId);
      if (!parentElement) return;

      const children = parentElement.querySelectorAll(`[id^="${childElementIdPrefix}"]`);

      let tallest = 0;
      children.forEach((el) => {
        const height = el.offsetHeight;
        if (height > tallest) tallest = height;
      });

      setMaxHeight(tallest);
    }, 300);

    return () => clearTimeout(timeout);
  }, [parentElementId, childElementIdPrefix, data, open, mobilitySettings]);

  return maxHeight;
};

export default useMaxHeightChildElement;
